import { memo } from 'react'

import { ReactComponent as Logo } from '@space-shell/assets/images/logo.svg'

import { LOGO_HEIGHT, LOGO_WIDTH } from './constants'

const MenuFooter = () => (
  <div slot='footer'>
    <footer className='_m-4 _overflow-hidden'>
      <div className='_d-flex _align-items-center _justify-content-center'>
        <>
          <p className='_text-1 _text-gray-500 _mb-0 _mr-2'>Powered by</p>
          <Logo width={LOGO_WIDTH} height={LOGO_HEIGHT} />
        </>
      </div>
    </footer>
  </div>
)

export default memo(MenuFooter)
